import { useZstdHeader } from 'header/header/useZstdHeader';
import { useLoginInfo, useSetLoginInfo } from 'hooks/useLoginInfo';
import { i18ntrans } from 'language/i18nkey';
import { IfLoginInfo } from 'models/IfLoginInfo';
import svcs from 'services';
import styled from 'styled-components';
import { loginutil } from 'util/loginutil';
import { useZstdInfo } from 'zstd/useZstdInfo';
import icon_logout from './icon/logout.svg';

type Props = {};
export const RenderLogoutMenu = (props: Props) => {
  const trans = (key: string): string => {
    return i18ntrans.header(key as any);
  };
  const { setShowUserPopup } = useZstdInfo();
  const setLoginInfo = useSetLoginInfo();

  const loginInfo = useLoginInfo();
  return (
    <Userstate>
      <button
        onClick={async () => {
          if (loginutil.islse(loginInfo)) {
            await svcs.svcLogin.logoutAdmin();
          } else {
            await svcs.svcLogin.logout();
          }
          window.localStorage.removeItem('RECENT_EXCEPT_LECTURE_VALUE');
          useZstdHeader.setState({ loginInputValues: { id: '', password: '' } });
          setShowUserPopup(false);
          setLoginInfo({} as IfLoginInfo);
          window.location.replace('/');
        }}
      >
        <img alt={'popup_logout.svg'} src={icon_logout} />
        {trans('I18N_TITLE_LOGOUT')}
      </button>
    </Userstate>
  );
};

const Userstate = styled.div`
  margin-bottom: 1.6rem;
  padding: 0 1rem;
  button {
    padding: 1.6rem 2.2rem;
  }
`;
